import React from 'react';

import { useSelector } from 'react-redux';

import Unified from './Unified';
import Company from './Company';

import useStyles from './styles';

function Main() {
  const classes = useStyles();

  const { companies: list = [] } = useSelector(state => state.sales);

  return (
    <div className={classes.root}>
      <Unified />
      <span className={classes.title}>empresas</span>
      <ul className={classes.list}>
        {list.map(item => (
          <Company key={item.id} item={item} />
        ))}
      </ul>
    </div>
  );
}

export default Main;
